<template>
  <Layout>
    <PageHeader :title="ptitle" :items="items" />
    <div class="row" v-if="userData.permissions['others'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-class size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New Event</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.title,
                            data.item.description,
                            data.item.startdate,
                            data.item.enddate,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id, data.item.title)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-class"
        centered
        title="New Event"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addEvent">
          <div class="form-group mb-2">
            <label>Title</label>
            <input v-model="title" type="text" class="form-control" />
            <label>Description</label>
            <textarea
              v-model="description"
              rows="2"
              class="form-control"
            ></textarea>
            <label>Start Date</label>
            <input
              v-model="startdate"
              type="datetime-local"
              class="form-control"
            />
            <label>End Date</label>
            <input
              v-model="enddate"
              type="datetime-local"
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-class')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-class"
        centered
        title="Edit Event"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editEvent">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Name</label>
            <input v-model="title" type="text" class="form-control" />
            <label>Description</label>
            <textarea
              v-model="description"
              rows="2"
              class="form-control"
            ></textarea>
            <label>Start Date</label>
            <input
              v-model="startdate"
              type="datetime-local"
              class="form-control"
            />
            <label>End Date</label>
            <input
              v-model="enddate"
              type="datetime-local"
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-class')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-class"
        centered
        title="Delete Event"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeEvent">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Event : <b>{{ title }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-class')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { schooleventMethods, schooleventComputed } from "@/state/helpers";

export default {
  page: {
    title: "Events",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      ptitle: "Events",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Events", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "title", label: "Title", visible: true },
        { key: "description", label: "Description", visible: true },
        { key: "startdate", label: "Start Date", visible: true },
        { key: "enddate", label: "End Date", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      title: "",
      description: "",
      startdate: new Date().toLocaleDateString("fr-CA"),
      enddate: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...schooleventComputed,
    List() {
      return this.schoolevents.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.schoolevents.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.schoolevents.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchSchoolEvents();
    this.TotalRows = this.schoolevents.length;
    this.isBusy = false;
  },
  methods: {
    ...schooleventMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, title, description, startdate, enddate) {
      this.id = id;
      this.title = title;
      this.description = description;
      this.startdate = startdate;
      this.enddate = enddate;
      this.$bvModal.show("edit-class");
    },
    remove(id, title) {
      this.id = id;
      this.title = title;
      this.$bvModal.show("delete-class");
    },
    async addEvent() {
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("startdate", this.startdate);
      formData.append("enddate", this.enddate);
      let url = "/addschoolevent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolEvents();
          this.$bvModal.hide("new-class");
          this.title = "";
          this.description = "";
          if (response.data.code == "200") {
            this.$swal({
              title: "Success",
              text: response.data.message,
              icon: "success",
            });
          } else {
            this.$swal({
              title: "Error",
              text: response.data.message,
              icon: "error",
            });
          }
        }
      });
    },
    async editEvent() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("startdate", this.startdate);
      formData.append("enddate", this.enddate);
      let url = "/editschoolevent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolEvents();
          this.$bvModal.hide("edit-class");
          this.title = "";
          this.description = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeEvent() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deleteschoolevent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolEvents();
          this.$bvModal.hide("delete-class");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
